import angular from 'angular';
import { concat, toUpper } from 'lodash';
import '../../app.constants';
import '../../services/place';
import '../../services/globals';
import '../../services/reception';
import '../../services/subscription';
import '../../services/errors';
import '../../services/redirect-to-new-version';
import '../../components/operator';
import '../../components/status';
import * as utils from '../../utils';

const module = angular.module('whyline.controllers.reception', [
  'whyline.constants',
  'whyline.services.place',
  'whyline.services.globals',
  'whyline.services.reception',
  'whyline.services.subscription',
  'whyline.services.errors',
  'whyline.services.redirect-to-new-version',
  'whyline.components.operator',
  'whyline.components.status',
]);

const ReceptionController = (
  SAFE_STATES,
  $rootScope,
  $scope,
  $state,
  $timeout,
  PlaceService,
  GlobalsService,
  ReceptionService,
  SubscriptionService,
  ErrorService,
  $translate,
  dialog,
  RedirectToNewVersionService,
) => {
  /* @ngInject */

  const identifications = PlaceService.getIdentificationsForCurrentPlace() || [];

  const selected = identifications.find((id) => id.default);

  // INIT values
  $scope.historyBtnForward = false;
  $scope.historyBtnBack = false;
  $scope.reception = {};
  $scope.currentPlaceId = '';
  $scope.showStatusView = false;
  $scope.showUserNumberView = false;
  $scope.showUserInfoView = false;
  $scope.isLangEn = $translate.use() === 'en';
  $scope.isLangPt = $translate.use() === 'pt';
  $scope.person = {
    firstName: '',
    lastName: '',
    idType: selected ? selected.key : undefined,
    id: '',
  };

  // HISTORY FUNCTIONALITY
  // This is a function to go back/forward between views
  // managing the different states saved in a Stack array
  $scope.history = (direction) => {
    if (direction === 'back') {
      $scope.directionForward = false;
    } else {
      $scope.directionForward = true;
    }
    ReceptionService.History(direction);
  };

  PlaceService.GetOneAsPromise(GlobalsService.CurrentPlace._id)
    .then((place) => {
      $scope.place = place;
      if ($scope.place.revertMigration) {
        const currentUser = utils.localStorage.get('user');
        RedirectToNewVersionService.Redirect(
          'reception',
          $scope.place._id,
          currentUser._id,
          '',
        ).then();
      }
      $scope.person.phone = {
        countryCode: toUpper(place.location.countryCode),
        full: '',
      };
    })
    .catch(ErrorService.handler);

  $scope.historyBtnStatus = ReceptionService.GetButtonStatus();

  // Update button status
  $rootScope.$on('$stateChangeSuccess', () => {
    $timeout(() => {
      $scope.directionForward = true;
      $scope.path = ReceptionService.GetPath();
      $scope.lastSelected = $scope.path[$state.params.n - 1];
      $scope.actualParams = $state.params;
      if ($state.current.name === SAFE_STATES.receptionStep && $state.params.n == 0) {
        if ($state.params.searchFrom === 'agenda') {
          ReceptionService.SetButtonStatus('back', false);
        } else {
          ReceptionService.SetButtonStatus('back', true);
        }
        ReceptionService.SetButtonStatus('forward', false);
        ReceptionService.SetButtonStatus('status-text', false);
      }
    });
  });

  const createItemsProp = (item) => {
    const mergedArray = [];
    $timeout(() => {
      if (item.type === 'sector') {
        item.items = concat(
          mergedArray,
          item.schemasPopulated,
          item.areasPopulated,
          item.linesPopulated,
        );
        return item;
      }
      if (item.type === 'area') {
        item.items = item.linesPopulated;
        return item;
      }
    });
  };

  //
  // SELECT OPTION
  $scope.select = (selected) => {
    const params = {};
    $scope.directionForward = true;
    if (selected.type === 'sector' || (selected.type === 'area' && selected.ordered === false)) {
      if (
        selected.type === 'sector' &&
        selected.tree.length &&
        selected.tree.length === 1 &&
        selected.tree[0].type === 'information-screen'
      ) {
        ReceptionService.SetInformationScreen(selected.tree[0]);
        return $state.go(SAFE_STATES.receptionInformationScreen);
      }
      createItemsProp(selected);
      ReceptionService.Select(selected);
      $timeout(() => {
        $scope.reception = ReceptionService.GetCurrent();
      });
    } else {
      ReceptionService.Select(selected);
      if (selected.realType === 'process') {
        params.areaId = selected._id;
        // eslint-disable-next-line prefer-destructuring
        params.lineId = selected.lines[0];
      } else if (selected.realType === 'line') {
        params.lineId = selected._id;
      }
      $state.go(SAFE_STATES.receptionStatus, params);
    }
  };

  $scope.requeue = (subscription) => {
    dialog
      .confirm(
        $translate
          .instant('confirm_requeue_{name}')
          .replace('{name}', subscription.person.firstName || ''),
      )
      .then(() => {
        SubscriptionService.Requeue(subscription);
      });
  };
};

module.exports = module.controller('ReceptionController', ReceptionController);
